import { render, staticRenderFns } from "./Agiliza.vue?vue&type=template&id=baff6866&scoped=true"
import script from "./Agiliza.vue?vue&type=script&lang=js"
export * from "./Agiliza.vue?vue&type=script&lang=js"
import style0 from "./Agiliza.vue?vue&type=style&index=0&id=baff6866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baff6866",
  null
  
)

export default component.exports